export var AccommodationSearchSortColumn = {
    AvailableStock: "available_stock",
    Name: "name",
    PriceTotal: "price_total"
};
export var AccommodationSearchSortOrder = {
    Asc: "asc",
    Desc: "desc"
};
export var AccommodationType = {
    Apartment: "apartment",
    Bungalow: "bungalow",
    BungalowTent: "bungalow_tent",
    CampingBarrel: "camping_barrel",
    Campsite: "campsite",
    Caravan: "caravan",
    Chalet: "chalet",
    Gipsywagon: "gipsywagon",
    HikerCabin: "hiker_cabin",
    HolidayHome: "holiday_home",
    Hotelroom: "hotelroom",
    LodgeTent: "lodge_tent",
    Mobilehome: "mobilehome",
    Other: "other",
    Pod: "pod",
    SafariTent: "safari_tent",
    Studio: "studio",
    Tipitent: "tipitent",
    Treehouse: "treehouse",
    Villa: "villa"
};
export var BookingService = {
    CampingCare: "camping_care",
    DormProject: "dormProject",
    None: "none",
    SimpleBooking: "simpleBooking"
};
export var CtaButtonDimensions = {
    Large: "LARGE",
    Medium: "MEDIUM",
    Small: "SMALL"
};
export var CtaButtonTheme = {
    Dark: "DARK",
    Light: "LIGHT"
};
export var CtaIconPosition = {
    After: "AFTER",
    Before: "BEFORE"
};
export var CtaIconType = {
    Arrow: "ARROW",
    None: "NONE"
};
export var CampingAdvisorSearchDisplayType = {
    ExternalCard: "external_card",
    FullImageCard: "full_image_card",
    TextCard: "text_card"
};
export var CampingAdvisorSearchItemType = {
    Article: "ARTICLE",
    Cta: "CTA"
};
export var CampsiteFeaturesScope = {
    All: "ALL",
    Highlighted: "HIGHLIGHTED"
};
export var CampsitePlaceType = {
    Campsite: "CAMPSITE",
    Region: "REGION"
};
export var CampsiteSearchDisplay = {
    Carousel: "CAROUSEL",
    List: "LIST",
    Map: "MAP"
};
export var CampsiteSearchType = {
    Accommodations: "ACCOMMODATIONS",
    All: "ALL",
    Pitches: "PITCHES"
};
export var EditorialTeasersMobileLayout = {
    Carousel: "CAROUSEL",
    Default: "DEFAULT",
    List: "LIST"
};
export var EmailObfuscationType = {
    Email: "EMAIL",
    Mailto: "MAILTO"
};
export var FrontifyVideoRatio = {
    Landscape: "landscape",
    Portrait: "portrait"
};
export var GuestAgeCategory = {
    Adults: "adults",
    Babies: "babies",
    Children: "children",
    Elderly: "elderly",
    Seniors: "seniors",
    YoungAdults: "young_adults",
    YoungChildren: "young_children"
};
export var ImageAspectRatio = {
    Ratio_3_2: "RATIO_3_2",
    Ratio_4_5: "RATIO_4_5",
    Ratio_5_4: "RATIO_5_4"
};
export var ImagePosition = {
    Left: "left",
    Right: "right"
};
export var LayoutVariant = {
    ContentPage: "content_page",
    LandingPage: "landing_page"
};
export var Locale = {
    De: "de",
    En: "en",
    Fr: "fr",
    It: "it"
};
export var OpeningHoursFacility = {
    Accommodation: "ACCOMMODATION",
    Campsite: "CAMPSITE",
    Pitch: "PITCH",
    Reception: "RECEPTION",
    Restaurant: "RESTAURANT",
    Self: "SELF"
};
export var Operator = {
    Empty: "EMPTY",
    Eq: "EQ",
    In: "IN",
    Neq: "NEQ",
    NotEmpty: "NOT_EMPTY",
    NotIn: "NOT_IN"
};
export var SeasonType = {
    AllYear: "ALL_YEAR",
    HighSeason: "HIGH_SEASON",
    LowSeason: "LOW_SEASON"
};
export var Theme = {
    Default: "default",
    Laax: "laax",
    Restaurant: "restaurant",
    Riverlodge: "riverlodge"
};
export var ThemeVariant = {
    Dark: "dark",
    Default: "default",
    Highlight: "highlight",
    Light: "light"
};
export var AccommodationSearchQuery = "AccommodationSearchQuery:cceec4fe7a5a75ee12eb62875a279521cf8bb4681dce4176241fdf878d65fd3f";
export var AddFeedbackMutation = "AddFeedbackMutation:c54579c5553aa4fa4ea336892ae8da6eadcf2c3060484034842db3eab9ccba50";
export var AddRatingMutation = "AddRatingMutation:b4ca9d21796c43b86864f511aa357bd0cc776010d4777cd5ab052683267db6cc";
export var AllAccommodationAttributesQuery = "AllAccommodationAttributesQuery:21d24e0e9dd8b1da06da9f7d2f2928ef3357b38d4de8fa325e255a8a6b3b6f44";
export var AllAccommodationTypeTermsQuery = "AllAccommodationTypeTermsQuery:d44a2aa7e2ebbfa38c0431ed0583362e2d9466d76aebb46136d383b48849e6e3";
export var AllCampsiteFeaturesQuery = "AllCampsiteFeaturesQuery:1c6389e560e5d6050e9034a3d692e7c901cbdc3b0d437900c1062a3248f1d6a4";
export var AllCampsiteRegionsQuery = "AllCampsiteRegionsQuery:48a64d78ffbe7f51ed55abd0ef404efe876001b6b23ee86227d6f8f027222f7c";
export var AllCampsitesQuery = "AllCampsitesQuery:a3c5001af63ed146d78afbd77d5063a0d312e7fb95eeede1039af7c07cc3fede";
export var CampingAdvisorSearchQuery = "CampingAdvisorSearchQuery:5149e767b0e0a1233b93f16ea9b7fcf7446870611368a2f4f62ee3cab0d4c570";
export var CreateSubmissionMutation = "CreateSubmissionMutation:b585180e5579cb960b45197ad15ac71e5dc70d92bc935df5e2c92574edcd8d37";
export var ContentHubQuery = "ContentHubQuery:6896f1193fcfcd01dd9490ecc19ffdebb3b2ae0da999a818b1d91d6352f1f61f";
export var FrameQuery = "FrameQuery:7ddcec58cbae4e0c5bc5745d59b81fcdbcea9cbe9413a6a41568303a07ad150b";
export var GetRatingQuery = "GetRatingQuery:55191feb45ea8f47514819b09afa84c5927deda11562e5693e56fbddb723ba32";
export var HomePageQuery = "HomePageQuery:a2f25641b67ee2869e76121a3742f3ed31720310aa0682432451abd362e0fd02";
export var ListPagesQuery = "ListPagesQuery:a179d1573d009fae6ff6a6f3a4d98e3bdfcc14d546a4b9cfc1468d50954faaff";
export var NotFoundPageQuery = "NotFoundPageQuery:96bc1a9d80e319def119d2f2c1e9d4964313ba1ed0ac4a1d5858debf2f165fc8";
export var PreviewDrupalPageQuery = "PreviewDrupalPageQuery:fc560b002786eca8ab14fe69fbdcf37504e8700ccbd3058b578fa1247fb83d9e";
export var SearchPageSettingsQuery = "SearchPageSettingsQuery:229fe76e28ee1bec767ebbb70c493f9cc4be55b63fd2241c4baa7edcf895046a";
export var ViewCampingAdvisorArticleQuery = "ViewCampingAdvisorArticleQuery:d9c5da8e4f8bac00c33dc9e79868767ab8939db94a3b6432fc6f8799756c54a9";
export var ViewCampingRestaurantQuery = "ViewCampingRestaurantQuery:2a3f5de4efb8146bb84676c412757d00f46aec6057539dba6496d0ca806c1c76";
export var ViewCampsiteQuery = "ViewCampsiteQuery:830ba5e7d35ccb22f0ea9eb11cf121b9016047ea8fa62afa984f70ddb13f97e6";
export var ViewCampsiteInformationQuery = "ViewCampsiteInformationQuery:130d222e735d2ac88ee41e457c9cb5a0a8304a58a846ed41557e6ddbff132e5b";
export var ViewPageQuery = "ViewPageQuery:a5a817b52289df7d644254c98279fdd178e6c608d3d59342407d3e8e13da7ca4";
